import React, { Component } from "react";
import { BASE_URL } from "../common/common";

const API_URL = BASE_URL;

const imgUrl = (path) => {
  if (!path) return null;
  if (path.startsWith("http")) return `${path}`;
  const cleanPath = path.startsWith("/") ? path.slice(1) : path;
  return `${API_URL}/${cleanPath}`;
};

// ── Empty factories ──────────────────────────
const emptyYoutube     = () => ({ url: "", title: 0, saving: false });
// ✅ Added subscription field
const emptyDirector    = () => ({ name: "", designation: "", subscription: "", quote: "", imagePreview: null, imageFile: null, saving: false });
const emptyTestimonial = () => ({ name: "", designation: "", company: "", review: "", rating: 5, imagePreview: null, imageFile: null, saving: false });

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab : "youtube",

      // ── YouTube
      youtubeView    : "list",
      youtubeList    : [],
      youtubeLoading : false,
      youtubeForm    : emptyYoutube(),
      editingYoutube : null,

      // ── Director's Corner
      directorView    : "list",
      directorList    : [],
      directorLoading : false,
      directorForm    : emptyDirector(),
      editingDirector : null,

      // ── Testimonials
      testimonialView    : "list",
      testimonialList    : [],
      testimonialLoading : false,
      testimonialForm    : emptyTestimonial(),
      editingTestimonial : null,

      successMessage : "",
      errorMessage   : "",
    };
  }

  componentDidMount() {
    this.fetchYoutube();
    this.fetchDirectors();
    this.fetchTestimonials();
  }

  showSuccess = (msg) => { this.setState({ successMessage: msg, errorMessage: "" }); setTimeout(() => this.setState({ successMessage: "" }), 3000); };
  showError   = (msg) => { this.setState({ errorMessage: msg, successMessage: "" }); setTimeout(() => this.setState({ errorMessage: "" }), 4000); };

  // ════════════════════════════════
  //  1. YOUTUBE URL
  // ════════════════════════════════

  fetchYoutube = async () => {
    this.setState({ youtubeLoading: true });
    try {
      const res  = await fetch(`${API_URL}/api/video/getVideoList`, { method: "GET", headers: { "ngrok-skip-browser-warning": "true" } });
      const json = await res.json();
      if (json.status) this.setState({ youtubeList: json.data || [], youtubeLoading: false });
      else this.setState({ youtubeLoading: false });
    } catch { this.setState({ youtubeLoading: false }); this.showError("Cannot connect to API."); }
  };

  openYoutubeForm = (item = null) => {
    this.setState({
      youtubeView    : "form",
      editingYoutube : item,
      youtubeForm    : item
        ? { url: item.videoUrl || "", title: item.title ?? 0, saving: false }
        : emptyYoutube(),
    });
  };

  goToYoutubeList = () => { this.setState({ youtubeView: "list", editingYoutube: null }); this.fetchYoutube(); };

  saveYoutube = async () => {
    const { youtubeForm, editingYoutube } = this.state;
    if (!youtubeForm.url.trim()) return this.showError("YouTube URL is required.");
    this.setState((prev) => ({ youtubeForm: { ...prev.youtubeForm, saving: true } }));
    try {
      const payload = { videoUrl: youtubeForm.url, is_thumbnail: Number(youtubeForm.title) };
      if (editingYoutube) payload.video_id = editingYoutube.video_id;
      const url = editingYoutube ? `${API_URL}/api/video/updateVideo` : `${API_URL}/api/video/addVideo`;
      const res  = await fetch(url, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload) });
      const json = await res.json();
      this.setState((prev) => ({ youtubeForm: { ...prev.youtubeForm, saving: false } }));
      if (json.status) { this.showSuccess(editingYoutube ? "Updated!" : "Saved!"); setTimeout(() => this.goToYoutubeList(), 1000); }
      else { this.showError(json.message || "Save failed."); }
    } catch { this.setState((prev) => ({ youtubeForm: { ...prev.youtubeForm, saving: false } })); this.showError("Cannot connect to API."); }
  };

  deleteYoutube = async (id) => {
    if (!window.confirm("Delete this YouTube URL?")) return;
    try {
      const res  = await fetch(`${API_URL}/api/video/deleteVideo`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ id }) });
      const json = await res.json();
      if (json.status) { this.showSuccess("Deleted."); this.fetchYoutube(); }
      else { this.showError(json.message || "Delete failed."); }
    } catch { this.showError("Cannot connect to API."); }
  };

  // ════════════════════════════════
  //  2. DIRECTOR'S CORNER
  // ════════════════════════════════

  fetchDirectors = async () => {
    this.setState({ directorLoading: true });
    try {
      const res  = await fetch(`${API_URL}/api/homeDirector/getHomeDirectors`, { method: "GET", headers: { "ngrok-skip-browser-warning": "true" } });
      const json = await res.json();
      if (json.status) this.setState({ directorList: json.data?.[0] || json.data || [], directorLoading: false });
      else this.setState({ directorLoading: false });
    } catch { this.setState({ directorLoading: false }); this.showError("Cannot connect to API."); }
  };

  openDirectorForm = (item = null) => {
    this.setState({
      directorView    : "form",
      editingDirector : item,
      directorForm    : item
        ? {
            name         : item.Name         || item.Name || "",
            designation  : item.Designation  || "",
            // ✅ subscription field
            subscription : item.subDescription || "",
            quote        : item.Description        || item.description   || "",
            imagePreview : null,
            imageFile    : null,
            saving       : false,
          }
        : emptyDirector(),
    });
  };

  goToDirectorList = () => { this.setState({ directorView: "list", editingDirector: null }); this.fetchDirectors(); };

  handleDirectorImg = (e) => {
    const file = e.target.files[0]; if (!file) return;
    const reader = new FileReader();
    reader.onloadend = () => this.setState((prev) => ({ directorForm: { ...prev.directorForm, imagePreview: reader.result, imageFile: file } }));
    reader.readAsDataURL(file);
  };

  saveDirector = async () => {
    const { directorForm, editingDirector } = this.state;
    if (!directorForm.name.trim()) return this.showError("Name is required.");
    this.setState((prev) => ({ directorForm: { ...prev.directorForm, saving: true } }));
    try {
      const fd = new FormData();
      fd.append("Name",         directorForm.name);
      fd.append("Designation",  directorForm.designation);
      // ✅ send subscription field
      fd.append("subDescription", directorForm.subscription);
      fd.append("Description",        directorForm.quote);
      if (directorForm.imageFile) fd.append("image", directorForm.imageFile);
      if (editingDirector) fd.append("directorID", editingDirector.directorID || editingDirector.directorID);
      const url = editingDirector ? `${API_URL}/api/homeDirector/updateHomeDirector ` : `${API_URL}/api/homeDirector/addHomeDirector`;
      const res  = await fetch(url, { method: "POST", body: fd });
      const json = await res.json();
      this.setState((prev) => ({ directorForm: { ...prev.directorForm, saving: false } }));
      if (json.status) { this.showSuccess(editingDirector ? "Updated!" : "Saved!"); setTimeout(() => this.goToDirectorList(), 1000); }
      else { this.showError(json.message || "Save failed."); }
    } catch { this.setState((prev) => ({ directorForm: { ...prev.directorForm, saving: false } })); this.showError("Cannot connect to API."); }
  };

  deleteDirector = async (id) => {
    if (!window.confirm("Delete this director entry?")) return;
    try {
      const res  = await fetch(`${API_URL}/api/homeDirector/deleteHomeDirector`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ id }) });
      const json = await res.json();
      if (json.status) { this.showSuccess("Deleted."); this.fetchDirectors(); }
      else { this.showError(json.message || "Delete failed."); }
    } catch { this.showError("Cannot connect to API."); }
  };

  // ════════════════════════════════
  //  3. WHAT CLIENT SAYS
  // ════════════════════════════════

  fetchTestimonials = async () => {
    this.setState({ testimonialLoading: true });
    try {
      const res  = await fetch(`${API_URL}/api/clientreview/getClientReviews`, { method: "GET", headers: { "ngrok-skip-browser-warning": "true" } });
      const json = await res.json();
      if (json.status) this.setState({ testimonialList: json.data?.[0] || json.data[0] || [], testimonialLoading: false });
      else this.setState({ testimonialLoading: false });
    } catch { this.setState({ testimonialLoading: false }); this.showError("Cannot connect to API."); }
  };

  openTestimonialForm = (item = null) => {
    this.setState({
      testimonialView    : "form",
      editingTestimonial : item,
      testimonialForm    : item
        ? {
            name         : item.clientName          || "",
            company      : item.clientCompanyName   || "",
            review       : item.review              || "",
            rating       : item.stars               || 5,
            imagePreview : null,
            imageFile    : null,
            saving       : false,
          }
        : emptyTestimonial(),
    });
  };

  goToTestimonialList = () => { this.setState({ testimonialView: "list", editingTestimonial: null }); this.fetchTestimonials(); };

  handleTestimonialImg = (e) => {
    const file = e.target.files[0]; if (!file) return;
    const reader = new FileReader();
    reader.onloadend = () => this.setState((prev) => ({ testimonialForm: { ...prev.testimonialForm, imagePreview: reader.result, imageFile: file } }));
    reader.readAsDataURL(file);
  };

  saveTestimonial = async () => {
    const { testimonialForm, editingTestimonial } = this.state;
    if (!testimonialForm.name.trim())    return this.showError("Client name is required.");
    if (!testimonialForm.company.trim()) return this.showError("Company is required.");
    if (!testimonialForm.review.trim())  return this.showError("Review is required.");
    this.setState((prev) => ({ testimonialForm: { ...prev.testimonialForm, saving: true } }));
    try {
      const fd = new FormData();
      fd.append("clientName",        testimonialForm.name);
      fd.append("clientCompanyName", testimonialForm.company);
      fd.append("review",            testimonialForm.review);
      fd.append("stars",             testimonialForm.rating);
      if (testimonialForm.imageFile) fd.append("image", testimonialForm.imageFile);
      if (editingTestimonial) fd.append("clientreviewID", editingTestimonial.clientreviewID);
      const url = editingTestimonial ? `${API_URL}/api/clientreview/updateClientReview` : `${API_URL}/api/clientreview/addClientReview`;
      const res  = await fetch(url, { method: "POST", body: fd });
      const json = await res.json();
      this.setState((prev) => ({ testimonialForm: { ...prev.testimonialForm, saving: false } }));
      if (json.status) { this.showSuccess(editingTestimonial ? "Updated!" : "Saved!"); setTimeout(() => this.goToTestimonialList(), 1000); }
      else { this.showError(json.message || "Save failed."); }
    } catch { this.setState((prev) => ({ testimonialForm: { ...prev.testimonialForm, saving: false } })); this.showError("Cannot connect to API."); }
  };

  deleteTestimonial = async (idx) => {
    if (!window.confirm("Delete this testimonial?")) return;
    try {
      const res  = await fetch(`${API_URL}/api/clientreview/deleteClientReview`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ id: idx }) });
      const json = await res.json();
      if (json.status) { this.showSuccess("Deleted."); this.fetchTestimonials(); }
      else { this.showError(json.message || "Delete failed."); }
    } catch { this.showError("Cannot connect to API."); }
  };

  // ════════════════════════════════
  //  HELPERS
  // ════════════════════════════════

  renderListHeader = (loading, count, label, onAdd, addLabel) => (
    <div className="rsp-list-top" style={s.listTopBar}>
      <span style={s.countText}>{loading ? "Loading..." : `${count} ${label}${count !== 1 ? "s" : ""} found`}</span>
      <button className="rsp-btn-save" style={s.btnSave} onClick={onAdd}>{addLabel}</button>
    </div>
  );

  renderEmpty = (label, onAdd, addLabel) => (
    <div style={s.emptyBox}>
      <p style={{ ...s.emptyText, marginBottom: "12px" }}>No {label} found.</p>
      <button className="rsp-btn-save" style={s.btnSave} onClick={onAdd}>{addLabel}</button>
    </div>
  );

  renderActions = (onEdit, onDelete) => (
    <div className="rsp-action-btns" style={s.actionBtns}>
      <button className="rsp-btn-edit" style={s.btnEdit}   onClick={onEdit}>Edit</button>
      <button className="rsp-btn-delete" style={s.btnDelete} onClick={onDelete}>Delete</button>
    </div>
  );

  renderFormTopBar = (title, onBack) => (
    <div className="rsp-form-top" style={s.formTopBar}>
      <button className="rsp-btn-back" style={s.btnBack} onClick={onBack}>Back to List</button>
      <h3 style={s.formTitle}>{title}</h3>
    </div>
  );

  renderFormActions = (onCancel, onSave, saving, label) => (
    <div className="rsp-form-actions" style={s.formActions}>
      <button className="rsp-btn-back" style={s.btnBack} onClick={onCancel}>Cancel</button>
      <button className="rsp-btn-save" style={s.btnSave} onClick={onSave} disabled={saving}>{saving ? "Saving..." : label}</button>
    </div>
  );

  renderStars = (rating) => "★".repeat(Math.max(0, Math.min(5, rating))) + "☆".repeat(Math.max(0, 5 - Math.min(5, rating)));

  // ════════════════════════════════
  //  RENDER
  // ════════════════════════════════
  render() {
    const {
      activeTab,
      youtubeView, youtubeList, youtubeLoading, youtubeForm, editingYoutube,
      directorView, directorList, directorLoading, directorForm, editingDirector,
      testimonialView, testimonialList, testimonialLoading, testimonialForm, editingTestimonial,
      successMessage, errorMessage,
    } = this.state;

    const TABS = ["youtube", "director", "testimonials"];
    const TAB_LABELS = { youtube: "YouTube URL", director: "Director's Corner", testimonials: "What Clients Say" };

    return (
      <div>
        <div className="page-header">
          <h2>Home Page Manager</h2>
          <p>Manage YouTube videos, Director's Corner and client testimonials.</p>
        </div>

        {successMessage && <div style={s.success}>{successMessage}</div>}
        {errorMessage   && <div style={s.error}>{errorMessage}</div>}

        <div style={{ ...s.tabRow, flexWrap: "wrap" }}>
          {TABS.map((tab) => (
            <button key={tab} style={activeTab === tab ? s.tabActive : s.tab} onClick={() => this.setState({ activeTab: tab })}>
              {TAB_LABELS[tab]}
            </button>
          ))}
        </div>

        {/* ══════════════════════════════
            1. YOUTUBE URL TAB
        ══════════════════════════════ */}
        {activeTab === "youtube" && (
          <div>
            {youtubeView === "list" && (
              <div>
                {this.renderListHeader(youtubeLoading, youtubeList.length, "video", () => this.openYoutubeForm(), "+ Add YouTube URL")}
                {youtubeLoading && <div style={s.emptyBox}><p style={s.emptyText}>Loading...</p></div>}
                {!youtubeLoading && youtubeList.length === 0 && this.renderEmpty("YouTube URLs", () => this.openYoutubeForm(), "+ Add First URL")}

                {!youtubeLoading && youtubeList.map((item, i) => {
                  const videoUrl    = item.videoUrl || "";
                  const isThumbnail = item.title === 1;
                  const videoId     = videoUrl.match(/(?:v=|youtu\.be\/)([^&\s?]+)/)?.[1];
                  return (
                    <div key={item.video_id || i} className="rsp-list-card" style={s.listCard}>
                      {videoId ? (
                        <img src={`https://img.youtube.com/vi/${videoId}/mqdefault.jpg`} alt="yt" className="rsp-thumb-wide" style={s.thumbWide} />
                      ) : (
                        <div style={{ ...s.thumbWide, background: "#ff0000", display: "flex", alignItems: "center", justifyContent: "center" }}>
                          <span style={{ color: "#fff", fontSize: "22px" }}>▶</span>
                        </div>
                      )}
                      <div style={{ flex: 1 }}>
                        <div style={s.cardTitle}>
                          <span style={{ maxWidth: "400px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", display: "inline-block" }}>
                            {videoUrl || "YouTube Video"}
                          </span>
                          <span style={s.idBadge}>ID: {item.video_id}</span>
                          {isThumbnail && (
                            <span style={{ background: "#e8f5e9", color: "#2e7d32", border: "1px solid #c8e6c9", borderRadius: "10px", padding: "2px 8px", fontSize: "11px", fontWeight: "600" }}>
                              ★ Thumbnail
                            </span>
                          )}
                        </div>
                        <p style={s.metaText}>{videoUrl}</p>
                      </div>
                      {this.renderActions(() => this.openYoutubeForm(item), () => this.deleteYoutube(item.video_id))}
                    </div>
                  );
                })}
              </div>
            )}

            {youtubeView === "form" && (
              <div>
                {this.renderFormTopBar(editingYoutube ? "Edit YouTube URL" : "Add YouTube URL", this.goToYoutubeList)}
                <div className="card">
                  <div className="rsp-form-group" style={s.formGroup}>
                    <label style={s.label}>YouTube Video URL *</label>
                    <input className="rsp-input" style={s.input} type="text" value={youtubeForm.url} placeholder="https://youtu.be/xxxx  or  https://www.youtube.com/watch?v=xxxx" onChange={(e) => this.setState((p) => ({ youtubeForm: { ...p.youtubeForm, url: e.target.value } }))} />
                    <span style={s.hint}>Paste the full YouTube video URL or short URL</span>
                  </div>
                  <div className="rsp-form-group" style={s.formGroup}>
                    <label style={s.label}>Set as Thumbnail Video?</label>
                    <div style={{ display: "flex", gap: "16px", alignItems: "center", marginTop: "4px" }}>
                      {[{ label: "Yes — Featured thumbnail (1)", value: 1 }, { label: "No — Regular video (0)", value: 0 }].map((opt) => (
                        <label key={opt.value} style={{ display: "flex", alignItems: "center", gap: "8px", cursor: "pointer", fontSize: "14px", color: "#555" }}>
                          <input type="radio" name="isThumbnail" checked={Number(youtubeForm.title) === opt.value} onChange={() => this.setState((p) => ({ youtubeForm: { ...p.youtubeForm, title: opt.value } }))} style={{ cursor: "pointer", width: "16px", height: "16px" }} />
                          {opt.label}
                        </label>
                      ))}
                    </div>
                    <span style={s.hint}>Set to "Yes" if this is the main featured video shown on the homepage</span>
                  </div>
                  {youtubeForm.url && (() => {
                    const vid = youtubeForm.url.match(/(?:v=|youtu\.be\/)([^&\s?]+)/)?.[1];
                    return vid ? (
                      <div className="rsp-form-group" style={s.formGroup}>
                        <label style={s.label}>Video Preview</label>
                        <img src={`https://img.youtube.com/vi/${vid}/mqdefault.jpg`} alt="preview" style={{ width: "320px", borderRadius: "8px", border: "1px solid #e8e8e8" }} />
                      </div>
                    ) : null;
                  })()}
                  {this.renderFormActions(this.goToYoutubeList, this.saveYoutube, youtubeForm.saving, editingYoutube ? "Update URL" : "Save URL")}
                </div>
              </div>
            )}
          </div>
        )}

        {/* ══════════════════════════════
            2. DIRECTOR'S CORNER TAB
        ══════════════════════════════ */}
        {activeTab === "director" && (
          <div>
            {directorView === "list" && (
              <div>
                {/* ✅ Show Add Director button only when there are LESS THAN 2 directors */}
                <div className="rsp-list-top" style={s.listTopBar}>
                  <span style={s.countText}>
                    {directorLoading ? "Loading..." : `${directorList.length} director${directorList.length !== 1 ? "s" : ""} found`}
                  </span>
                  {directorList.length < 5 && (
                    <button className="rsp-btn-save" style={s.btnSave} onClick={() => this.openDirectorForm()}>+ Add Director</button>
                  )}
                </div>
                {directorLoading && <div style={s.emptyBox}><p style={s.emptyText}>Loading...</p></div>}
                {!directorLoading && directorList.length === 0 && this.renderEmpty("director entries", () => this.openDirectorForm(), "+ Add First Director")}

                {!directorLoading && directorList.map((item, i) => {
                  const imageUrl = item.imageUrl || item.imageUrl || item.imageUrl;
                  return (
                    <div key={item.directorID || item.directorID || i} className="rsp-list-card" style={s.listCard}>
                      {imageUrl ? (
                        <img src={imgUrl(imageUrl)} alt={item.Name} style={s.directorThumb} />
                      ) : (
                        <div style={s.directorInitial}>{(item.Name || item.Name || "?").charAt(0).toUpperCase()}</div>
                      )}
                      <div style={{ flex: 1 }}>
                        <div style={s.cardTitle}>
                          {item.Name || item.Name || "—"}
                          <span style={s.idBadge}>ID: {item.directorID || item.directorID}</span>
                        </div>
                        {item.Designation && <p style={{ fontSize: "12px", color: "#e8a020", marginBottom: "2px" }}>{item.Designation}</p>}
                        {/* ✅ Show subscription in list */}
                        {item.Description && (
                          <p style={{ fontSize: "11px", color: "#1565c0", marginBottom: "2px" }}>
                            🔗 {item.Description.length > 60 ? item.Description.substring(0, 60) + "..." : item.Description}
                          </p>
                        )}
                        {(item.Designation || item.Designation) && (
                          <p style={s.metaText}>"{(item.Designation || item.Designation).substring(0, 100)}..."</p>
                        )}
                      </div>
                      {this.renderActions(() => this.openDirectorForm(item), () => this.deleteDirector(item.directorID || item.directorID))}
                    </div>
                  );
                })}
              </div>
            )}

            {directorView === "form" && (
              <div>
                {this.renderFormTopBar(editingDirector ? `Edit — ${directorForm.name || editingDirector.name}` : "Add Director", this.goToDirectorList)}
                <div className="card">

                  {/* Photo */}
                  <div className="rsp-form-group" style={s.formGroup}>
                    <label style={s.label}>Director Photo</label>
                    {editingDirector && !directorForm.imagePreview && (editingDirector.imageUrl || editingDirector.image || editingDirector.photo) && (
                      <div style={{ marginBottom: "10px" }}>
                        <p style={s.hint}>Current photo:</p>
                        <img src={imgUrl(editingDirector.imageUrl || editingDirector.image || editingDirector.photo)} alt="current" style={s.currentImg} />
                      </div>
                    )}
                    {directorForm.imagePreview ? (
                      <div style={{ display: "flex", gap: "14px", alignItems: "flex-start" }}>
                        <img src={directorForm.imagePreview} alt="preview" style={{ width: "90px", height: "90px", objectFit: "cover", borderRadius: "50%", border: "2px solid #e8e8e8" }} />
                        <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                          <label className="rsp-btn-dark" style={s.btnDark}>Change Photo<input type="file" accept="image/*" onChange={this.handleDirectorImg} style={{ display: "none" }} /></label>
                          <button className="rsp-btn-delete" style={s.btnDelete} onClick={() => this.setState((p) => ({ directorForm: { ...p.directorForm, imagePreview: null, imageFile: null } }))}>Remove</button>
                        </div>
                      </div>
                    ) : (
                      <label className="rsp-upload-box" style={s.uploadBox}>
                        <p style={s.uploadText}>Click to upload director photo</p>
                        <p style={s.uploadHint}>JPG, PNG — square image recommended</p>
                        <input type="file" accept="image/*" onChange={this.handleDirectorImg} style={{ display: "none" }} />
                      </label>
                    )}
                  </div>

                  {/* Name + Designation */}
                  <div className="rsp-two-col" style={s.twoCol}>
                    <div className="rsp-form-group" style={s.formGroup}>
                      <label style={s.label}>Full Name *</label>
                      <input className="rsp-input" style={s.input} type="text" value={directorForm.name} placeholder="e.g. Nadeem Anwar" onChange={(e) => this.setState((p) => ({ directorForm: { ...p.directorForm, name: e.target.value } }))} />
                    </div>
                    <div className="rsp-form-group" style={s.formGroup}>
                      <label style={s.label}>Designation</label>
                      <input className="rsp-input" style={s.input} type="text" value={directorForm.designation} placeholder="e.g. Founder & Director" onChange={(e) => this.setState((p) => ({ directorForm: { ...p.directorForm, designation: e.target.value } }))} />
                    </div>
                  </div>

                  {/* ✅ NEW — Subscription field */}
                  <div className="rsp-form-group" style={s.formGroup}>
                    <label style={s.label}>
                      Subscription
                      <span style={{ color: "#aaa", fontWeight: "400", marginLeft: "6px" }}>(LinkedIn / YouTube / Website URL)</span>
                    </label>
                    <input
                      className="rsp-input" style={s.input}
                      type="text"
                      value={directorForm.subscription}
                      placeholder="e.g. https://linkedin.com/in/nadeem-anwar"
                      onChange={(e) => this.setState((p) => ({ directorForm: { ...p.directorForm, subscription: e.target.value } }))}
                    />
                    <span style={s.hint}>Enter a social profile or website link for this director</span>
                  </div>

                  {/* Quote */}
                  <div className="rsp-form-group" style={s.formGroup}>
                    <label style={s.label}>Quote / Message</label>
                    <textarea className="rsp-textarea" style={s.textarea} value={directorForm.quote} placeholder="A true Lucknowi at heart..." rows={4} onChange={(e) => this.setState((p) => ({ directorForm: { ...p.directorForm, quote: e.target.value } }))} />
                  </div>

                  {this.renderFormActions(this.goToDirectorList, this.saveDirector, directorForm.saving, editingDirector ? `Update ${directorForm.name || "Director"}` : `Save ${directorForm.name || "Director"}`)}
                </div>
              </div>
            )}
          </div>
        )}

        {/* ══════════════════════════════
            3. WHAT CLIENTS SAY TAB
        ══════════════════════════════ */}
        {activeTab === "testimonials" && (
          <div>
            {testimonialView === "list" && (
              <div>
                {this.renderListHeader(testimonialLoading, testimonialList.length, "testimonial", () => this.openTestimonialForm(), "+ Add Testimonial")}
                {testimonialLoading && <div style={s.emptyBox}><p style={s.emptyText}>Loading...</p></div>}
                {!testimonialLoading && testimonialList.length === 0 && this.renderEmpty("testimonials", () => this.openTestimonialForm(), "+ Add First Testimonial")}

                {!testimonialLoading && testimonialList.map((item, i) => {
                  const imageUrl = item.image_url || item.photo;
                  const rating   = item.stars || 5;
                  const review   = item.review || "";
                  return (
                    <div key={item.clientreviewID || i} className="rsp-list-card" style={s.listCard}>
                      {imageUrl ? (
                        <img src={imgUrl(imageUrl)} alt={item.clientName} style={s.clientThumb} />
                      ) : (
                        <div style={s.clientInitial}>{(item.clientName || "?").charAt(0).toUpperCase()}</div>
                      )}
                      <div style={{ flex: 1 }}>
                        <div style={s.cardTitle}>
                          {item.clientName || "—"}
                          <span style={s.idBadge}>ID: {item.clientreviewID}</span>
                          <span style={{ color: "#f4c430", fontSize: "13px" }}>{this.renderStars(Number(rating))}</span>
                        </div>
                        {item.clientCompanyName && <p style={{ fontSize: "12px", color: "#e8a020", marginBottom: "4px" }}>{item.clientCompanyName}</p>}
                        {review && <p style={s.metaText}>"{review.replace(/<[^>]*>/g, "").substring(0, 120)}..."</p>}
                      </div>
                      {this.renderActions(() => this.openTestimonialForm(item), () => this.deleteTestimonial(item.clientreviewID))}
                    </div>
                  );
                })}
              </div>
            )}

            {testimonialView === "form" && (
              <div>
                {this.renderFormTopBar(editingTestimonial ? `Edit — ${editingTestimonial.clientName}` : "Add Testimonial", this.goToTestimonialList)}
                <div className="card">
                  <div className="rsp-form-group" style={s.formGroup}>
                    <label style={s.label}>Client Photo <span style={{ color: "#aaa", fontWeight: "400" }}>(optional)</span></label>
                    {editingTestimonial && (editingTestimonial.image_url) && (
                      <div style={{ marginBottom: "10px" }}>
                        <p style={s.hint}>Current photo:</p>
                        <img src={imgUrl(editingTestimonial.image_url)} alt="current" style={s.currentImg} />
                      </div>
                    )}
                    {testimonialForm.imagePreview ? (
                      <div style={{ display: "flex", gap: "14px", alignItems: "flex-start" }}>
                        <img src={testimonialForm.imagePreview} alt="preview" style={{ width: "80px", height: "80px", objectFit: "cover", borderRadius: "50%", border: "2px solid #e8e8e8" }} />
                        <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                          <label className="rsp-btn-dark" style={s.btnDark}>Change<input type="file" accept="image/*" onChange={this.handleTestimonialImg} style={{ display: "none" }} /></label>
                          <button className="rsp-btn-delete" style={s.btnDelete} onClick={() => this.setState((p) => ({ testimonialForm: { ...p.testimonialForm, imagePreview: null, imageFile: null } }))}>Remove</button>
                        </div>
                      </div>
                    ) : (
                      <label className="rsp-upload-box" style={s.uploadBox}>
                        <p style={s.uploadText}>Click to upload client photo</p>
                        <p style={s.uploadHint}>JPG, PNG — square image recommended</p>
                        <input type="file" accept="image/*" onChange={this.handleTestimonialImg} style={{ display: "none" }} />
                      </label>
                    )}
                  </div>
                  <div className="rsp-two-col" style={s.twoCol}>
                    <div className="rsp-form-group" style={s.formGroup}>
                      <label style={s.label}>Client Name *</label>
                      <input className="rsp-input" style={s.input} type="text" value={testimonialForm.name} placeholder="e.g. Rohan Gupta" onChange={(e) => this.setState((p) => ({ testimonialForm: { ...p.testimonialForm, name: e.target.value } }))} />
                    </div>
                    <div className="rsp-form-group" style={s.formGroup}>
                      <label style={s.label}>Company *</label>
                      <input className="rsp-input" style={s.input} type="text" value={testimonialForm.company} placeholder="e.g. HCL Technologies" onChange={(e) => this.setState((p) => ({ testimonialForm: { ...p.testimonialForm, company: e.target.value } }))} />
                    </div>
                  </div>
                  <div className="rsp-form-group" style={s.formGroup}>
                    <label style={s.label}>Rating</label>
                    <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                      {[1, 2, 3, 4, 5].map((star) => (
                        <button key={star} type="button" onClick={() => this.setState((p) => ({ testimonialForm: { ...p.testimonialForm, rating: star } }))}
                          style={{ background: "none", border: "none", cursor: "pointer", fontSize: "28px", color: star <= testimonialForm.rating ? "#f4c430" : "#ddd", lineHeight: 1 }}>★</button>
                      ))}
                      <span style={{ fontSize: "13px", color: "#888", marginLeft: "6px" }}>{testimonialForm.rating}/5</span>
                    </div>
                  </div>
                  <div className="rsp-form-group" style={s.formGroup}>
                    <label style={s.label}>Review / Testimonial *</label>
                    <textarea style={{ ...s.textarea, minHeight: "120px" }} value={testimonialForm.review} placeholder="Write what the client said about TNA Events..." onChange={(e) => this.setState((p) => ({ testimonialForm: { ...p.testimonialForm, review: e.target.value } }))} />
                  </div>
                  {this.renderFormActions(this.goToTestimonialList, this.saveTestimonial, testimonialForm.saving, editingTestimonial ? `Update ${testimonialForm.name || "Testimonial"}` : `Save ${testimonialForm.name || "Testimonial"}`)}
                </div>
              </div>
            )}
          </div>
        )}

      </div>
    );
  }
}

const s = {
  success        : { background: "#e8f5e9", color: "#2e7d32", border: "1px solid #c8e6c9", borderRadius: "8px", padding: "12px 16px", marginBottom: "16px", fontSize: "14px" },
  error          : { background: "#ffebee", color: "#c62828", border: "1px solid #ffcdd2", borderRadius: "8px", padding: "12px 16px", marginBottom: "16px", fontSize: "14px" },
  tabRow         : { display: "flex", gap: "6px", borderBottom: "2px solid #e8e8e8", marginBottom: "20px" },
  tab            : { padding: "10px 18px", background: "none", border: "none", borderBottom: "3px solid transparent", fontSize: "13px", color: "#888", cursor: "pointer", marginBottom: "-2px", fontWeight: "500", whiteSpace: "nowrap" },
  tabActive      : { padding: "10px 18px", background: "none", border: "none", borderBottom: "3px solid #e8a020", fontSize: "13px", color: "#e8a020", cursor: "pointer", marginBottom: "-2px", fontWeight: "600", whiteSpace: "nowrap" },
  listTopBar     : { display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "16px" },
  countText      : { fontSize: "14px", color: "#888" },
  listCard       : { background: "white", borderRadius: "10px", padding: "16px 18px", border: "1px solid #e8e8e8", marginBottom: "12px", display: "flex", alignItems: "center", gap: "14px" },
  cardTitle      : { fontSize: "15px", color: "#1a1a2e", fontWeight: "600", display: "flex", alignItems: "center", gap: "8px", marginBottom: "4px", flexWrap: "wrap" },
  idBadge        : { background: "#f0f2f5", color: "#888", border: "1px solid #e0e0e0", borderRadius: "10px", padding: "2px 8px", fontSize: "11px", fontWeight: "400" },
  metaText       : { fontSize: "12px", color: "#888", marginTop: "2px", lineHeight: "1.5" },
  emptyBox       : { background: "white", borderRadius: "10px", padding: "48px 20px", border: "1px solid #e8e8e8", textAlign: "center" },
  emptyText      : { color: "#aaa", fontSize: "14px" },
  thumbWide      : { width: "120px", height: "68px", objectFit: "cover", borderRadius: "6px", border: "1px solid #e8e8e8", flexShrink: 0 },
  directorThumb  : { width: "60px", height: "60px", objectFit: "cover", borderRadius: "50%", border: "2px solid #e8e8e8", flexShrink: 0 },
  directorInitial: { width: "60px", height: "60px", background: "#1a1a2e", color: "#e8a020", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "22px", fontWeight: "700", flexShrink: 0 },
  clientThumb    : { width: "55px", height: "55px", objectFit: "cover", borderRadius: "50%", border: "2px solid #e8e8e8", flexShrink: 0 },
  clientInitial  : { width: "55px", height: "55px", background: "#1a1a2e", color: "#e8a020", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "20px", fontWeight: "700", flexShrink: 0 },
  actionBtns     : { display: "flex", flexDirection: "column", gap: "6px", flexShrink: 0 },
  btnEdit        : { background: "#e3f2fd", color: "#1565c0", border: "1px solid #bbdefb", padding: "6px 14px", borderRadius: "6px", fontSize: "12px", cursor: "pointer", fontWeight: "600", minWidth: "64px" },
  btnDelete      : { background: "#ffebee", color: "#c62828", border: "1px solid #ffcdd2", padding: "6px 14px", borderRadius: "6px", fontSize: "12px", cursor: "pointer", fontWeight: "600", minWidth: "64px" },
  formTopBar     : { display: "flex", alignItems: "center", gap: "14px", marginBottom: "16px" },
  formTitle      : { fontSize: "16px", color: "#1a1a2e", margin: 0 },
  formActions    : { display: "flex", justifyContent: "flex-end", gap: "10px", borderTop: "1px solid #f0f0f0", paddingTop: "16px" },
  formGroup      : { marginBottom: "18px" },
  label          : { display: "block", fontSize: "13px", color: "#555", fontWeight: "600", marginBottom: "6px" },
  input          : { width: "100%", padding: "10px 14px", border: "1px solid #ddd", borderRadius: "8px", fontSize: "14px", outline: "none", fontFamily: "Arial, sans-serif", boxSizing: "border-box" },
  textarea       : { width: "100%", padding: "10px 14px", border: "1px solid #ddd", borderRadius: "8px", fontSize: "14px", outline: "none", minHeight: "90px", resize: "vertical", fontFamily: "Arial, sans-serif", boxSizing: "border-box" },
  uploadBox      : { display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", border: "2px dashed #ddd", borderRadius: "10px", padding: "28px 20px", cursor: "pointer", background: "#fafafa", textAlign: "center" },
  uploadText     : { fontSize: "14px", color: "#555", marginBottom: "4px" },
  uploadHint     : { fontSize: "11px", color: "#aaa" },
  currentImg     : { width: "160px", height: "80px", objectFit: "cover", borderRadius: "6px", border: "1px solid #e8e8e8" },
  hint           : { fontSize: "12px", color: "#888", marginTop: "5px", display: "block" },
  btnDark        : { background: "#1a1a2e", color: "#fff", border: "none", padding: "7px 14px", borderRadius: "6px", fontSize: "12px", cursor: "pointer", fontWeight: "600" },
  btnSave        : { background: "#e8a020", color: "#fff", border: "none", padding: "10px 20px", borderRadius: "8px", fontSize: "14px", fontWeight: "600", cursor: "pointer" },
  btnBack        : { background: "#f0f2f5", color: "#333", border: "1px solid #ddd", padding: "9px 16px", borderRadius: "8px", fontSize: "13px", cursor: "pointer", fontWeight: "500" },
  twoCol         : { display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px" },
  threeCol       : { display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "16px" },
};

export default Home;